import { render, staticRenderFns } from "./GeneralConfigurationView.vue?vue&type=template&id=25efd2aa&scoped=true"
import script from "./GeneralConfigurationView.vue?vue&type=script&lang=js"
export * from "./GeneralConfigurationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25efd2aa",
  null
  
)

export default component.exports